module.exports = __webpack_public_path__ + "static/media/info_privacy.e222b9b3.png";